import { PixiBase } from './PixiBase';
import { pixiResourceHelper } from '../../helpers/pixiResourceHelper';
import { initGameLoopManager } from '../../lib/gameLoop';
import { initGameTimer } from '../../lib/timer';
import { resourceCount } from './resources';
import { loadingStore } from '../../store/loadingStore';
import { iframeService } from '../../services/iframeService';
// eslint-disable-next-line no-unused-vars
let timeOutId = null;
export class PixiGameDrawer {
  constructor({ PIXI, Spine, config }) {
    PixiBase.PIXI = PIXI;
    PixiBase.Spine = Spine;
    this.pixiApplication = PixiBase.createApplication({
      ...config,
      // antialias: false,
      // useContextAlpha: true,
      powerPreference: 'low-power',
      // autoDensity: true,
      // clearBeforeRender: false,
      // antialias: true,
      // autoScale: true,
      // roundPixels: false,
      resolution: 1.5,
    });

    initGameLoopManager(this.pixiApplication);
    initGameTimer(this.pixiApplication);
    this.stage = this.pixiApplication.stage;
  }

  scalePixiAppStage(scaleValue) {
    this.pixiApplication.stage.scale = scaleValue;
  }

  setupContainers(containers) {
    this.stage.addChild(...containers);
  }

  loadResource({ resource, loader }) {
    let loadedResourceCount = 0;
    timeOutId = setTimeout(() => {
      iframeService.reloadFrame();
    }, 40000);
    return new Promise((resolve) => {
      resource.forEach((item) => {
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in item) {
          loader.add(key, item[key].path, item[key].config);
          // eslint-disable-next-line no-loop-func
          loader.load(key).then((res) => {
            pixiResourceHelper.declareResources({ [key]: res });
            // if (item[key].isNeedResourceForLoading) { todo
            loadedResourceCount += 1;
            // }
            if (loadedResourceCount === resourceCount) {
              loadingStore.updateLoading({ isPixiLoaded: true });
              clearTimeout(timeOutId);
              resolve();
            }
          });
        }
      });
    });
  }
  // export const getAssets = async arg => {
  //   let result = {};
  //   const assets = await PIXI.Assets.get(arg);
  //   if (Array.isArray(arg)) {
  //     arg.forEach((item, index) => {
  //       result[item] = assets[index];
  //     });
  //   } else {
  //     result = assets;
  //   }
  //
  //   return result;
  // };
}
